import { HTTPClient } from '../utils/request'

export default {
  getNotificationByUser: ({ params }) =>
    HTTPClient.get(`/notification/driverNear/${params.user_id}`),
  all: ({ filter }) => HTTPClient.get(`/notification/driverNear${filter}`),
  update: ({ params, payload }) =>
    HTTPClient.put(`/notification/driverNear/${params.id}`, payload),
  getDriversNear: () => HTTPClient.get(`/drivers/near`)
}
